import React, { useState } from 'react';
import { useQuery } from 'react-query';

import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { getURLFile } from 'utils/utils2';
import {
  getPrintListByCriteria,
  GetPrintListByCriteriaParams,
  Print,
} from 'services/printingService';
import ModalControllerNV from 'components/ModalControllerNV';
import { API_URLS } from 'utils/config';
import ParListSelect from 'components/ParListSelect';
import PreviewPrintModal from './PreviwModal';
import ThirdPartyInput from 'components/ThirdPartyInput';
import ProposalSelect from 'components/ProposalSelect';
import AssetSelect from 'components/AssetSelect';
import SupplierInvoiceSelect from 'components/SupplierInvoiceSelect';
import ClientInvoiceSelect from 'components/ClientInvoiceSelect';
import PaymentSelect from 'components/PaymentSelect';
import CollectionSelect from 'components/CollectionSelect';
import DocCodePrintSelect from 'components/ParPrintDocSelect';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import CollectionDetailModal from 'components/CollectionDetailModal';
import { Form } from 'antd';
type PrintingListProps = {
  docmodule?:string;
  poreference?:string
};
const PrintingList = (props:PrintingListProps) => {
  const getUrl = (printid: number) =>
    `${PRINTING_URL}/api/print/download?printid=${printid}`;
  const [url, seturl] = useState('initialState');
  const [searchs, setsearchs] = useState(false);
  const [checkdocmodule, setcheckdocmodule] = useState('');
  const [printtype, setprinttype] = useState('');
  const [searchParams, setSearchParams] =
    useState<GetPrintListByCriteriaParams>({
      cireference: '' as any,
      ctreference: '' as any,
      doccode: '' as any,
      docmodule: props.docmodule??'' as any,
      mgid: Number(localStorage.getItem('mgid')),
      payreference: '' as any,
      poreference:  props.poreference??'' as any,
      printstatus: '' as any,
      sireference: '' as any,
      tpname: '' as any,
      tpreference: '' as any,
      colreference: '' as any,
      printtype: '' as any,
    });
  const {
    data: print,
    refetch,
    isFetching,
  } = useQuery(
    ['getPrintListByCriteria', searchParams],
    () => getPrintListByCriteria(searchParams).then((res) => res.list || []),
    { enabled: searchs, staleTime: MINUTE }
  );
  const [Params, setParams] = useState<any>({
    isLoading: false,
    objectname: '',
    previewImage: '',
    previewVisibleDOC: false,
    previewTitle: '',
    isPDF: false,
    showAddDocument: false,
    doccode: '',
    doctype: '',
    loadingUpload: false,
    enableUpload: false,
    ok: true,
  });
  const [form] = Form.useForm();

  const handlePreviewDOC = (fileurl: any) => {
    let ext = fileurl.substring(fileurl.lastIndexOf('.') + 1);

    setParams({
      previewVisibleDOC: true,
      previewTitle: fileurl.substring(fileurl.lastIndexOf('/') + 1),
      previewImage: fileurl,
      isPDF: ext === 'pdf' ? true : false,
    });
  };
  const handleCancelPreviewDOC = () => setParams({ previewVisibleDOC: false });
  const PRINTING_URL = API_URLS.PRINTING;

  const columns: DataGridColDef<Print>[] = [
    {
      dataIndex: 'docmodule',
      filtrable: 'docmodule',
      filterComponent: (
        <ParListSelect
          onClear={() => {
            setcheckdocmodule('');
            form.resetFields();
          }}
          allowClear
          parcode="DOCMODULE"
          onSelect={(e) => {
            setcheckdocmodule(e);
           
          }}
        />
      ),

      width: 100,
      fixed: true,
    },
    {
      dataIndex: 'printtype',
      filtrable: true,
      fixed: true,
      width: 80,
      filterComponent: (
        <ParListSelect
          parcode="PRINTCAT"
          onSelect={(e) => {
            setprinttype(e);
           
          }}
        />
      ),
    },
    {
      dataIndex: 'doclabel',
      fixed: true,
      filterComponent: (
        <DocCodePrintSelect
          entity={checkdocmodule}
          type={printtype}
          style={{ width: '100%' }}
        />
      ),
      filtrable: 'doccode',
      render: (value, record, index) => (
        <ModalControllerNV
          modal={({ setVisible, visible }) => (
            <PreviewPrintModal
              onCancel={() => {
                setVisible(false);
                refetch();
                handleCancelPreviewDOC();
              }}
              visible={visible}
              doccode={record.doccode}
              url={url}
              Params={Params}
            />
          )}
          content={({ setVisible, visible }) => (
            <a
              onClick={() => {
                setVisible(true);
                getURLFile('', getUrl(record.printid)).then((res) =>
                  seturl(res)
                );
               
                handlePreviewDOC(record.filename);
              }}
            >
              {record.doclabel}
            </a>
          )}
        />
      ),

      width: 150,
    },

    {
      dataIndex: 'printstatus',
      width: 80,
    },
    {
      dataIndex: 'tpreference',
      filtrable:
        checkdocmodule === 'THIRDPARTY' || checkdocmodule === 'PROPOSAL'
          ? true
          : false,
      filterComponent: <ThirdPartyInput />,
      width: 100,
      render: (value, record) => {
        return (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <ThirdPartyModal
                tpId={record.tpid}
                visible={visible}
                onCancel={() => setVisible(false)}
                onSuccess={() => setVisible(false)}
                title={value}
              />
            )}
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{value}</a>
            )}
          />
        );
      },
    },
    {
      dataIndex: 'ctreference',
      filtrable:
        checkdocmodule === 'PROPOSAL' || checkdocmodule === 'CONTRACT'
          ? true
          : false,
      filterComponent: (
        <div>
          {checkdocmodule === 'CONTRACT' ? (
            <ProposalSelect PropOrProd="PROD" phase="CONTRACT" onlyctrid />
          ) : (
            <ProposalSelect onlyctrid isCreate/>
          )}
        </div>
      ),
      render: (value, record) => {
        return (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <ProposalModal
                ctrid={record.ctrid}
                visible={visible}
                onCancel={() => setVisible(false)}
                onSuccess={() => setVisible(false)}
                title=""
                iscreate={false}
              />
            )}
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{record.ctreference}</a>
            )}
          />
        );
      },
      width: 100,
    },
    {
      dataIndex: 'colreference',
      filtrable: checkdocmodule === 'COLLECTION' ? true : false,
      filterComponent: <CollectionSelect />,
      width: 100,
      render: (value, record) => {
        return (
          <ModalControllerNV
            content={({ setVisible, visible }) => (
              <a
                onClick={() => {
                  setVisible(true);
                }}
              >
                {record.colreference}
              </a>
            )}
            modal={({ setVisible, visible }) => (
              <CollectionDetailModal
                visible={visible}
                onCancel={() => setVisible(false)}
                colidp={Number(record.colid)}
              />
            )}
          />
        );
      },
    },

    {
      dataIndex: 'assetreference',
      filtrable: checkdocmodule === 'ASSET' ? true : false,
      filterComponent: <AssetSelect onlyAssetId />,
      width: 100,
    },

    {
      dataIndex: 'cireference',
      filtrable: checkdocmodule === 'CINVOICE' ? true : false,
      filterComponent: <ClientInvoiceSelect />,
      width: 100,
      render: (value, record) => {
        return (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <CIDetail
                ciid={record.ciid}
                onCancel={() => setVisible(false)}
                showAsModal
                visible={visible}
                showButtons={false}
              />
            )}
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{value}</a>
            )}
          />
        );
      },
    },

    {
      dataIndex: 'payreference',
      filtrable: checkdocmodule === 'PAYMENT' ? true : false,
      filterComponent: <PaymentSelect onlyPayid />,
      width: 100,
    },
    {
      dataIndex: 'poreference',
      width: 100,
    },
    {
      dataIndex: 'sireference',
      filtrable: checkdocmodule === 'SINVOICE' ? true : false,
      filterComponent: <SupplierInvoiceSelect onlysiid />,
      width: 100,
    },

    {
      dataIndex: 'contenttype',
      width: 100,
    },
    {
      dataIndex: 'emailsubject',
      width: 200,
    },
    {
      dataIndex: 'emailto',
      width: 200,
    },
    {
      dataIndex: 'filename',
      width: 310,
    },

    {
      dataIndex: 'doctemplate',
      width: 100,
    },

    {
      dataIndex: 'printdate',
      width: 200,
    },
    {
      dataIndex: 'printstatusdate',
      width: 200,
    },
  ];

  return (
    <DF.Provider pagcode="printinglist">
      <DataGrid
        titleComcode="printinglist"
        columns={columns}
        dataSource={print}
        isLoading={isFetching}
        initialSearchValues={searchParams}
        onSearch={(values) => {
          setSearchParams({
            ...searchParams,
            tpreference: values.tpreference.tpreference,
            cireference: values.cireference.cireference,
            ctreference: values.ctreference,
            doccode: values.doccode,
            docmodule: values.docmodule,
            mgid: values.mgid,
            payreference: values.payreference,
            poreference: values.poreference,
            printstatus: values.printstatus,
            sireference: values.sireference,
            tpname: values.tpname,
            colreference: values.colreference.colreference,
            printtype: values.printtype,
          });
          setsearchs(true);
          refetch();
        }}
        onClear={() => {
          setSearchParams({ ...searchParams });
          refetch();
          form.resetFields();
          setSearchParams({
            ...searchParams ,
            cireference: '' ,
            ctreference: '' ,
            doccode: '' ,
            docmodule: '' ,
            mgid: 0 ,
            payreference: '' ,
            poreference: '' ,
            printstatus: '' ,
            sireference: '' ,
            tpname: '' ,
            tpreference: '' ,
            colreference: '',
            printtype: '' ,
          });
        }}
        size="small"
      />
    </DF.Provider>
  );
};
const SECOND = 1000;
const MINUTE = 60 * SECOND;
export default PrintingList;
